import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-transaction",
  templateUrl: "./med-icon-transaction.component.html",
})
export class MedIconTransactionComponent extends SvgMixinComponent {}
